import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../_services/session/session.service';

@Injectable({
  providedIn: 'root',
})
export class StatsGuard  {
  constructor(private session: SessionService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const customer = this.session.getCustomer();
    const site = this.session.getSite();
    const hasPermission = this.session.hasPermission(
      customer,
      site,
      'STATISTICS.READ'
    );
    if (!!!hasPermission) {
      return this.router.navigate(['']);
    }

    return hasPermission;
  }
}
